var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7270",
    d: "M0 0H6.593V6.674H0z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:currentColor}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8414",
    transform: "translate(-24 -611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7438",
    fill: "none",
    d: "M0 0H31V31H0z",
    transform: "translate(24 611)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8411",
    transform: "translate(-719.223 328.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8102",
    transform: "translate(745 285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5938",
    d: "M110.966 76.961a1.337 1.337 0 1 0-1.89 0 1.337 1.337 0 0 0 1.89 0",
    className: "cls-1",
    transform: "translate(-94.186 -64.717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5939",
    d: "M23.161 3.974A13.569 13.569 0 0 0 .541 17.368 4.468 4.468 0 0 0 2.4 19.694a3.405 3.405 0 0 0 3.777-.194l3.847-3.334-.01-.009a2.406 2.406 0 0 1-.83-1.59c-1.229.095-3.214.378-3.214.378l1.418-2.741s1.229-2.736 4.912-1.318c.567-.756 4.3-4.159 8.388-4.442-.284 4.088-3.686 7.821-4.442 8.388 1.418 3.686-1.323 4.915-1.323 4.915l-2.723 1.41-.015.007s.284-1.985.378-3.214a2.409 2.409 0 0 1-1.6-.84l-.05.058-3.283 3.79a3.405 3.405 0 0 0-.189 3.781 4.469 4.469 0 0 0 2.326 1.856A13.569 13.569 0 0 0 23.161 3.974",
    className: "cls-1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8104",
    transform: "translate(750.97 299.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8103",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5940",
    d: "M38.3 23.164a.481.481 0 0 0 .045-.088l-.015.007s.284-1.985.378-3.213a2.409 2.409 0 0 1-1.6-.84l-.05.058c.392 1.4 1.17 4.146 1.24 4.076",
    className: "cls-1",
    transform: "translate(-32.114 -16.491)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5941",
    d: "M3.214 0C1.985.095 0 .378 0 .378L4.043 1.59A2.407 2.407 0 0 1 3.214 0",
    className: "cls-1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.80d5bc2f4d65f2bdaa45ca5d1f8615e9.svg";
export { ForwardRef as ReactComponent };